import React from "react";

const IndexViewSec = React.lazy(() => import('../pages-sec/index/index'));
const HomeViewSec = React.lazy(() => import('../pages-sec/home/index'));

export{
    IndexViewSec,
    HomeViewSec
}